export interface PaginatedListRequest {
  limit?: number;
  nextToken?: string;
  fields?: string[];
}

export interface PaginatedListResponse<T> {
  items: T[];
  nextToken?: string;
}

const DEFAULT_LIMIT = 100;
const FULL_FETCH_LIMIT = 250;

function buildQuery(request: PaginatedListRequest): string {
  const params = new URLSearchParams();
  params.set("limit", `${request.limit || DEFAULT_LIMIT}`);
  if (request.nextToken) {
    params.set("nextToken", request.nextToken);
  }
  if (request.fields && request.fields.length > 0) {
    params.set("fields", request.fields.join(","));
  }
  return params.toString();
}

export async function fetchListPage<T>(
  endpoint: string,
  fetchJson: (url: string) => Promise<unknown>,
  request: PaginatedListRequest = {}
): Promise<PaginatedListResponse<T>> {
  const response = await fetchJson(`${endpoint}?${buildQuery(request)}`);
  if (Array.isArray(response)) {
    return { items: response as T[] };
  }
  const page = response as Partial<PaginatedListResponse<T>>;
  return {
    items: page.items || [],
    nextToken: page.nextToken,
  };
}

export async function fetchAllList<T>(
  endpoint: string,
  fetchJson: (url: string) => Promise<unknown>
): Promise<T[]> {
  const items: T[] = [];
  let nextToken: string | undefined;
  do {
    const page = await fetchListPage<T>(endpoint, fetchJson, {
      limit: FULL_FETCH_LIMIT,
      nextToken,
    });
    items.push(...page.items);
    nextToken = page.nextToken;
  } while (nextToken);
  return items;
}
